<template>
  <div class="body-container">
    <component
      v-for="(item, index) in detailComponentList"
      v-bind="item.props"
      class="body-content"
      :key="index"
      :ref="`component_${item.type}_${index}`"
      :is="item.component"
      :is-edit-mode="false"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import TextComponent from '@/components/company/detail/text.vue'
import Picture from '@/components/company/detail/picture.vue'
import Slide from '@/components/company/detail/slide.vue'
import Video from '@/components/company/detail/video.vue'

export default {
  components: {
    TextComponent,
    Picture,
    Slide,
    Video
  },
  props: {
    company: {
      type: Object,
      default: () => {}
    },
    webPageItems: {
      type: Array,
      default: () => []
    }
  },
  metaInfo () {
    return {
      title: this.pageTitle
    }
  },
  data () {
    return {
      menuSetting: {},
      companySurvey: {},
      endInitData: false,
      showChatbot: false,
      routerAlive: true,
      typeMapping: {
        text: {
          type: 'text',
          component: TextComponent,
          props: {}
        },
        picture: {
          type: 'picture',
          component: Picture,
          props: {}
        },
        silder: {
          type: 'slide',
          component: Slide,
          props: {}
        },
        video: {
          type: 'video',
          component: Video,
          props: {}
        }
      }
    }
  },
  computed: {
    companyId () {
      return this.$route.params.companyId
    },
    isEn () {
      return this.$i18n.locale === 'en'
    },
    pageTitle () {
      const title = this.isEn ? this.company?.name : this.company?.cn_name
      return this.$t('companyJobList.label.detailPageTitleText', { name: title })
    },
    detailComponentList () {
      const list = []
      if (this.webPageItems?.length) {
        _.forEach(this.webPageItems, (item, index) => {
          if (this.typeMapping[item.type]) {
            const componentSetting = { ...this.typeMapping[item.type] }
            componentSetting.props = {
              value: item
            }
            list.push(componentSetting)
          }
        })
      }
      return list
    }
  },
  created () {
  },
  methods: {
    async reloadPage () {
      this.routerAlive = false
      this.$nextTick(() => {
        this.routerAlive = true
      })
    }
  },
  watch: {
    '$i18n.locale' () {
      this.reloadPage()
    }
  }
}
</script>

<style lang="scss" scoped>
.body-container {
  width: 980px;
  ::v-deep {
    ul, ol {
      margin: 0;
      padding-left: 20px;
      list-style-type: disc;
    }
    ol {
      list-style-type: decimal;
    }
  }
}
</style>
